import type { FlowNode } from '@lighthouse/shared'
import { X_OFFSET, Y_OFFSET } from '@lighthouse/shared'
import { nanoid } from '@lighthouse/tools'
import { clone } from 'rambda'

type FlowPosition = {
    x: number
    y: number
}

type MutableFlowNode = FlowNode & {
    dragging?: boolean
    height?: number
    measured?: {
        height?: number
        width?: number
    }
    positionAbsolute?: {
        x: number
        y: number
    }
    resizing?: boolean
    width?: number
}

const resetFlowNodeTransientState = (node: MutableFlowNode) => {
    delete node.connectedSourceHandleIds
    delete node.dragging
    delete node.height
    delete node.measured
    delete node.positionAbsolute
    delete node.resizing
    delete node.selected
    delete node.width
    delete node.data.status
}

export const createFlowNodeClipboardSnapshot = (node: FlowNode): FlowNode => {
    const snapshot = clone(node) as MutableFlowNode
    resetFlowNodeTransientState(snapshot)
    return snapshot
}

export const createPastedFlowNode = (node: FlowNode, pasteCount: number, position?: FlowPosition) => {
    const nextPasteCount = pasteCount + 1
    const pastedNode = createFlowNodeClipboardSnapshot(node) as MutableFlowNode

    pastedNode.id = nanoid()
    pastedNode.position = position ?? {
        x: (node.position?.x ?? 0) + X_OFFSET * nextPasteCount,
        y: (node.position?.y ?? 0) + Y_OFFSET * nextPasteCount
    }

    return {
        node: pastedNode as FlowNode,
        pasteCount: nextPasteCount
    }
}
